import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validates that the input is a valid phone format.
 * Requires that the phone number consist in only numeric characters and optional whitespaces.
 */
export function customPhoneValidator(): ValidatorFn {
	const phoneRegex = /^(?:\+?(?:\(\d{1,4}\)|\d{1,4})[\s\d]+)?$/; // Accepts empty input, or an optional '+' at the beginning, followed by a country/area code with matching parentheses if used, then digits and whitespaces

	return (control: AbstractControl): ValidationErrors | null => {
		const value = control.value;

		if (!value || phoneRegex.test(value)) {
			return null;
		}

		return { invalidPhone: true };
	};
}
